var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 0.833618C8.27582 0.833618 8.49967 1.05748 8.49967 1.33362V2.00028C8.49967 2.27643 8.27582 2.50028 7.99967 2.50028C7.72353 2.50028 7.49967 2.27643 7.49967 2.00028V1.33362C7.49967 1.05748 7.72353 0.833618 7.99967 0.833618Z",
    fill: "#E9EAF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16634 8.00029C4.16634 5.88319 5.88258 4.16695 7.99967 4.16695C10.1168 4.16695 11.833 5.88319 11.833 8.00029C11.833 10.1174 10.1168 11.8336 7.99967 11.8336C5.88258 11.8336 4.16634 10.1174 4.16634 8.00029ZM7.99967 5.16695C6.43487 5.16695 5.16634 6.43548 5.16634 8.00029C5.16634 9.56509 6.43487 10.8336 7.99967 10.8336C9.56448 10.8336 10.833 9.56509 10.833 8.00029C10.833 6.43548 9.56448 5.16695 7.99967 5.16695Z",
    fill: "#E9EAF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63919 2.9327C3.44393 2.73744 3.12735 2.73744 2.93209 2.9327C2.73682 3.12796 2.73682 3.44455 2.93209 3.63981L3.40349 4.11121C3.59875 4.30648 3.91533 4.30648 4.1106 4.11121C4.30586 3.91595 4.30586 3.59937 4.1106 3.40411L3.63919 2.9327Z",
    fill: "#E9EAF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1663 8.00029C15.1663 8.27643 14.9425 8.50029 14.6663 8.50029H13.9997C13.7235 8.50029 13.4997 8.27643 13.4997 8.00029C13.4997 7.72414 13.7235 7.50029 13.9997 7.50029H14.6663C14.9425 7.50029 15.1663 7.72414 15.1663 8.00029Z",
    fill: "#E9EAF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0673 3.6398C13.2625 3.44454 13.2625 3.12796 13.0673 2.9327C12.872 2.73743 12.5554 2.73743 12.3602 2.9327L11.8887 3.4041C11.6935 3.59936 11.6935 3.91594 11.8887 4.11121C12.084 4.30647 12.4006 4.30647 12.5959 4.11121L13.0673 3.6398Z",
    fill: "#E9EAF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 13.5003C8.27582 13.5003 8.49967 13.7241 8.49967 14.0003V14.667C8.49967 14.9431 8.27582 15.167 7.99967 15.167C7.72353 15.167 7.49967 14.9431 7.49967 14.667V14.0003C7.49967 13.7241 7.72353 13.5003 7.99967 13.5003Z",
    fill: "#E9EAF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5959 11.8894C12.4006 11.6941 12.0841 11.6941 11.8888 11.8894C11.6935 12.0846 11.6935 12.4012 11.8888 12.5965L12.3602 13.0679C12.5555 13.2631 12.872 13.2631 13.0673 13.0679C13.2626 12.8726 13.2626 12.556 13.0673 12.3608L12.5959 11.8894Z",
    fill: "#E9EAF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49967 8.00029C2.49967 8.27643 2.27582 8.50029 1.99967 8.50029H1.33301C1.05687 8.50029 0.833008 8.27643 0.833008 8.00029C0.833008 7.72414 1.05687 7.50029 1.33301 7.50029H1.99967C2.27582 7.50029 2.49967 7.72414 2.49967 8.00029Z",
    fill: "#E9EAF0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11055 12.5965C4.30581 12.4012 4.30581 12.0846 4.11055 11.8894C3.91529 11.6941 3.59871 11.6941 3.40345 11.8894L2.93204 12.3608C2.73678 12.556 2.73678 12.8726 2.93204 13.0679C3.1273 13.2631 3.44389 13.2631 3.63915 13.0679L4.11055 12.5965Z",
    fill: "#E9EAF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.61cdee2b917f1a3c8dd626af60258566.svg";
export { ForwardRef as ReactComponent };